module.exports = PIXI.particles;


//////////////////
// WEBPACK FOOTER
// external "PIXI.particles"
// module id = 100
// module chunks = 0 4 6 10